<template>
  <div id="content">
    <h1>关于SteemJiang</h1>

    <img src="https://i.loli.net/2019/11/17/7P943k5rebDV1zX.jpg" alt=""><br><br>

    SteemJiang是一个定制且精简的Steem区块链自媒体，@lemooljiang创建。它做了很多的前端优化，使用起来相当丝滑！<br><br>

    SteemJiang是一个纯粹的前端应用！ 它和比特币的离线钱包类似，可以很方便地在本地构建，无需服务器。<br><br>

    当然，为了方便大家使用，我把它上传到github page中，大家可以直接访问：https://lemooljiang.github.io<br><br>

    <h4>本地构建说明</h4>
    本地环境：Apache 或 Nginx<br>
    仓库地址： https://github.com/lemooljiang/lemooljiang.github.io<br>
    将仓库中的“index.html” 和 “static” 下载到本地，放进Apache 或 Nginx的根目录即可，http://localhost<br><br>


  </div>
</template>

<script>

  export default {
    name: "About",
    data() {
      return {

      }
    },

    mounted() {


    },

  }
</script>

<style scoped>
  h1{
    font-size: 2rem;
    padding-left: 25%;
    padding-bottom: 1rem;
    border-bottom: 1px solid #ddd;
  }
  #content{
    color: rgba(55,53,58,0.75);
    align: center;
    margin: 1rem auto;
    width: 75%;
    padding-bottom: 0.2rem;
  }

  a{
    color: rgba(55,53,58,0.75);
  }

  a:hover{
    color: darkcyan;
    text-decoration: none;
  }

  .btn-outline-primary {
    color: rgba(55,53,58,0.75);
    border-color: rgba(55,53,58,0.75);
  }
  .btn-outline-primary:hover{
    background-color: chocolate;
  }
</style>

